<template>
    <div>
        <v-dialog v-if="dataSource" v-model="isVisible" transition="dialog-top-transition" scrollable persistent max-width="700">
            <v-card class="modal-maincard">

                <v-toolbar dark flat dense>
                    <v-toolbar-title>{{this.title}}</v-toolbar-title>
                </v-toolbar>

                <v-card-text class="wrapperFormModal">
                    <v-card flat>
                        <v-card-text>
                            <v-form ref="form" lazy-validation :key="formRerenderKey">
                                <template v-for="(item, itemKey) in dataSource">
                                    <v-row no-gutters v-if="item.group.label" :key=skey+itemKey+item.group.name>
                                        <v-col  cols="12" sm="12" md="12">
                                            <label class="f-label">{{$t(item.group.label)}}</label>
                                        </v-col>
                                    </v-row>
                                    <template v-for="(value, valueKey) in item.values">
                                        <component 
                                            :is="value.field.componentName" 
                                            :items="value.field.reference ? getItems(value.field) :  null"                                            
                                            :key=skey+itemKey+valueKey 
                                            :label="value.field.label" 
                                            :value="value.field.value" 
                                            @input="e => updateField({ property: `[${itemKey}].values[${valueKey}].field.value`, value: e, name: value.name })" 
                                            :rules="requiredRule"                                            
                                        />
                                    </template>
                                </template>
                            </v-form>
                        
                        </v-card-text>
                    </v-card>  
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn 
                        color="cyan"
                        text
                        depressed
                        @click="ok"
                        v-if="isValid"
                    >
                        {{ $t("Сформировать_и_отправить") }} 
                    </v-btn>

                    <v-btn 
                        color="blue-grey" 
                        text
                        depressed 
                        @click="cancel"
                    >
                        {{$t("Отменить")}}
                    </v-btn>

                </v-card-actions>

            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import i18n from '@/i18n'
import { mapActions, mapGetters } from 'vuex';
import sys from '@/services/system';

export default {
    name: "cscFormContract",
    data () {
        return {
            //title: i18n.t("Сформировать_договор_и_отправить_заявителю"),
            contractDateMenu: false,
            formRerenderKey: 0,
        }
    },
    filters: {
        formattedDate: function (value) {
            return sys.dateFormat(value, 'DD.MM.YYYY') ?? "";
        }
    },
    computed: {
        ...mapGetters('references', { getReferenceByName: 'GetReferenceByName' }),
        ...mapGetters('dialogs/cscContractInfo', ['isPending', 'isVisible', 'isValid', 'dataSource', 'skey', 'serviceCode']),
        ...mapGetters({ requiredRule: 'getRequiredRule' }),
        title(){
            if (this.serviceCode == '01040047' || this.serviceCode == '01040053')
                return i18n.t("Сформировать_соглашение_и_отправить_заявителю");
            else 
                return i18n.t("Сформировать_договор_и_отправить_заявителю");
        }
    },    
    methods: {
        ...mapActions('dialogs/cscContractInfo', ['ok', 'cancel', 'updateDataSource']),        
        validateForm() {
            this.$refs?.form?.validate();    
        },
        getItems(field){
            
            if (!field.reference)
                return null;

            let reference = this.getReferenceByName(field.reference);

            if (!reference)
                return null;

            return reference.map(x => ({id: x.id, Value: i18n.t(x.Value)}));
        },
        async updateField(data){
            await this.updateDataSource(data);
            if (this.serviceCode == '01050008'){
                const itemKey = parseInt(data.property.split('.')[0].slice(1, -1));
                if ((data.name == "ContractDate" || data.name == "ContractBeginDate") && !isNaN(itemKey)){
                    let valueKey = -1;
                    if (data.name == "ContractDate"){
                        valueKey = this.dataSource[itemKey].values.findIndex(v => v.name == "ContractBeginDate");
                        if (valueKey != -1){
                            this.updateDataSource({property: `[${itemKey}].values[${valueKey}].field.value`, value: data.value});
                        }
                    }
                    valueKey = this.dataSource[itemKey].values.findIndex(v => v.name == "ContractEndDate");
                    if (valueKey != -1){
                        const endDate = this.$moment(data.value).add(1, 'years').add(-1, 'days').format('YYYY-MM-DD');
                        this.updateDataSource({property: `[${itemKey}].values[${valueKey}].field.value`, value: endDate});
                    }

                    this.formRerenderKey += 1;
                }
               
            }
        }
    },
    updated() {
        this.$nextTick(function () {
            if (this.isVisible)
                this.validateForm();
        });
    },
}
</script>